export function submitCountryLocalization(form, countryCode) {
  if (!form) return;
  const destination = {
    AT: { language: 'de', root: '/de-at' },
    BE: { language: 'fr', root: '/fr-be' },
    CH: { language: 'de', root: '/de-ch' },
    DE: { language: 'de', root: '/de-de' },
    FR: { language: 'fr', root: '/fr-fr' },
    US: { language: 'en', root: '' }
  }[countryCode];
  if (destination) {
    let languageInput = form.querySelector('[name="language_code"]');
    if (!languageInput) {
      languageInput = document.createElement('input');
      languageInput.type = 'hidden';
      languageInput.name = 'language_code';
      form.append(languageInput);
    }
    if (languageInput.tagName === 'SELECT' && !Array.from(languageInput.options).some((option) => option.value === destination.language)) {
      languageInput.add(new Option(destination.language, destination.language));
    }
    languageInput.value = destination.language;
    let returnInput = form.querySelector('[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      form.append(returnInput);
    }
    const destinationUrl = new URL(returnInput.value || window.location.href, window.location.origin);
    const resourcePath = destinationUrl.pathname.replace(/^\/(?:en|de|fr)(?:-(?:de|at|fr|ch|be))?(?=\/|$)/, '') || '/';
    destinationUrl.searchParams.delete('locale');
    destinationUrl.searchParams.delete('language');
    returnInput.value = destination.root + resourcePath + destinationUrl.search + destinationUrl.hash;
  }
  form.submit();
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLSelectElement) || !input.matches('[data-beedo-country-selector]')) return;
  submitCountryLocalization(input.form, input.value);
});
